export function traverseAndFlatten(data, { iteratee, path = "" }) {
    if (Array.isArray(data)) {
        return data.flatMap((v, index) => traverseAndFlatten(v, { iteratee, path: `${path}[${index}]` }));
    }
    // Since null datas are allowed but typeof null === "object", the "&& data" is used to skip this
    if (typeof data === "object" && data) {
        return Object.keys(data).flatMap((key) => traverseAndFlatten(data[key], { iteratee, path: path ? `${path}.${key}` : key }));
    }
    if (typeof data === "string" || typeof data === "number" || typeof data === "boolean" || data === null) {
        return iteratee({ value: data, path });
    }
    throw new Error(`Unexpected data '${data}' in '${path}'`);
}
